import React from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import classNames from 'classnames/bind';

import { SelectPassengerFormValue } from './SelectPassengerForm';

import styles from './SelectPassengerForm.module.scss';

const cx = classNames.bind(styles);

const SelectPassengerDisplay = () => {
  const { control } = useFormContext();
  const personalCount = useWatch<SelectPassengerFormValue, 'personalCount'>({ control, name: 'personalCount' });

  return (
    <div className={cx('total')}>
      <span className={cx('text')}>총 인원</span>
      <span className={cx('value')}>성인 {personalCount?.adult}</span>
      <span className={cx('value')}>소아 {personalCount?.child}</span>
      <span className={cx('value')}>유아 {personalCount?.infant}</span>
    </div>
  );
};

export default SelectPassengerDisplay;
